import { useFetchGeneralPage } from "hooks/CMS/GeneralPage/useFetchGeneralPage";
import GeneralPageTemplate from "components/CMSEnabled/GeneralPageTemplate/CMSTemplate";
import * as styles from "./HelpAtHand.module.scss";
import { useEffect } from "react";
import useGetEmbeddedURLs from "hooks/PowerBi/GetEmbeddedURLs/useGetEmbeddedURLs";
import PowerBiReport from "components/PowerBi/Report/PowerBiReport";
import useCheckFeatureFlag from "hooks/useCheckFeatureFlag";
import { roleCheck } from "utils/User/Roles";
import { useAppSelector } from "hooks/reduxhooks";
import { Navigate } from "react-router-dom";
import { featureFlags } from "../../../constants/constants";
import APP_URL_CONSTS from "../../../navigation/AppUrls";

const HelpAtHandMi = () => {
  const { loading, setLoading, error, setError, generalPage } =
    useFetchGeneralPage();
  const userRole = useAppSelector((state) => state.userSlice.role);
  const canAccessPage = roleCheck(["help-at-hand-mi"], userRole);
  const { enabled, ready } = useCheckFeatureFlag(
    featureFlags.reportingRestriction,
  );

  const { reports, refreshReport } = useGetEmbeddedURLs([
    "EngagementSurvey",
    "ServiceUsage",
    "360WellbeingScore",
    "Feedback",
  ]);

  useEffect(() => {
    if (error.isError) {
      setLoading(false);
      setError({ isError: false, errorType: undefined, errorMessage: "" });
    }
  }, [error, setLoading, setError]);


  if (ready && enabled && !canAccessPage) {
    return <Navigate to={APP_URL_CONSTS.FORBIDDEN} replace />;
  }

  return (
    <GeneralPageTemplate
      showLoadingWhenEmpty={false}
      loading={{
        isLoading: loading,
        style: { maxHeight: "800px" },
        loadingPlaceholderCount: 3,
      }}
      isError={error.isError}
      generalPage={generalPage}
      sectionClass={styles.CMSSection}
    >
      <div className={styles.reportWrapper}>
        {reports.map((report) => (
          <div key={report.id}>
            <PowerBiReport
              report={report}
              onRetry={(id) => {
                refreshReport(id);
              }}
            ></PowerBiReport>
          </div>
        ))}
      </div>
    </GeneralPageTemplate>
  );
};

export default HelpAtHandMi;
